import { ComplexValue } from 'app/types-shared';
import { AdministrationMessageItem, MessagesValidation } from './types-store';

export const ACTION = {
  REQUEST_LANGUAGE_OPTIONS: 'MESSAGES_ADMINISTRATION_FORM:REQUEST_LANGUAGE_OPTIONS',
  RECEIVE_LANGUAGE_OPTIONS: 'MESSAGES_ADMINISTRATION_FORM:RECEIVE_LANGUAGE_OPTIONS',
  FAIL_LANGUAGE_OPTIONS: 'MESSAGES_ADMINISTRATION_FORM:FAIL_LANGUAGE_OPTIONS',

  REQUEST_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:REQUEST_MESSAGE',
  RECEIVE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:RECEIVE_MESSAGE',
  FAIL_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:FAIL_MESSAGE',

  REQUEST_DELETE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:REQUEST_DELETE_MESSAGE',
  RECEIVE_DELETE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:RECEIVE_DELETE_MESSAGE',
  FAIL_DELETE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:FAIL_DELETE_MESSAGE',

  REQUEST_SAVE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:REQUEST_SAVE_MESSAGE',
  RECEIVE_SAVE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:RECEIVE_SAVE_MESSAGE',
  FAIL_SAVE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:FAIL_SAVE_MESSAGE',

  CLEAR_FORM: 'MESSAGES_ADMINISTRATION_FORM:CLEAR_FORM',

  CHANGE_SUBJECT: 'MESSAGES_ADMINISTRATION_FORM:CHANGE_SUBJECT',
  CHANGE_MESSAGE: 'MESSAGES_ADMINISTRATION_FORM:CHANGE_MESSAGE',
  COPY_SUBJECT_TO_ALL: 'MESSAGES_ADMINISTRATION_FORM:COPY_SUBJECT_TO_ALL',
  COPY_MESSAGE_TO_ALL: 'MESSAGES_ADMINISTRATION_FORM:COPY_MESSAGE_TO_ALL',

  CHANGE_ACTIVE: 'MESSAGES_ADMINISTRATION_FORM:CHANGE_ACTIVE',

  UPDATE_VALIDATION: 'MESSAGES_ADMINISTRATION_FORM:UPDATE_VALIDATION'
};

export class RequestLanguageOptions {
  public type: string = ACTION.REQUEST_LANGUAGE_OPTIONS;
}

export class ReceiveLanguageOptions {
  public type: string = ACTION.RECEIVE_LANGUAGE_OPTIONS;
  constructor(public options: ComplexValue<number>[]) { }
}

export class FailLanguageOptions {
  public type: string = ACTION.FAIL_LANGUAGE_OPTIONS;
}

export class RequestMessage {
  public type: string = ACTION.REQUEST_MESSAGE;
  constructor(public messageId: number) { }
}

export class ReceiveMessage {
  public type: string = ACTION.RECEIVE_MESSAGE;
  constructor(public messageId: number, public message: AdministrationMessageItem) { }
}

export class FailMessage {
  public type: string = ACTION.FAIL_MESSAGE;
  constructor(public messageId: number) { }
}

export class RequestDeleteMessage {
  public type: string = ACTION.REQUEST_DELETE_MESSAGE;
  constructor(public messageId: number) { }
}

export class ReceiveDeleteMessage {
  public type: string = ACTION.RECEIVE_DELETE_MESSAGE;
  constructor(public messageId: number) { }
}

export class FailDeleteMessage {
  public type: string = ACTION.FAIL_DELETE_MESSAGE;
  constructor(public messageId: number) { }
}

export class RequestSaveMessage {
  public type: string = ACTION.REQUEST_SAVE_MESSAGE;
  constructor(public messageId: number) { }
}

export class ReceiveSaveMessage {
  public type: string = ACTION.RECEIVE_SAVE_MESSAGE;
  constructor(public messageId: number) { }
}

export class FailSaveMessage {
  public type: string = ACTION.FAIL_SAVE_MESSAGE;
  constructor(public messageId: number) { }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class ChangeSubject {
  public type: string = ACTION.CHANGE_SUBJECT;
  constructor(public languageId: number, public subject: string) { }
}

export class ChangeMessage {
  public type: string = ACTION.CHANGE_MESSAGE;
  constructor(public languageId: number, public message: string) { }
}

export class CopySubjectToAll {
  public type: string = ACTION.COPY_SUBJECT_TO_ALL;
  constructor(public languageId: number) { }
}

export class CopyMessageToAll {
  public type: string = ACTION.COPY_MESSAGE_TO_ALL;
  constructor(public languageId: number) { }
}

export class ChangeActive {
  public type: string = ACTION.CHANGE_ACTIVE;
  constructor(public active: boolean) { }
}

export class UpdateValidation {
  public type: string = ACTION.UPDATE_VALIDATION;
  constructor(public validation: MessagesValidation) { }
}
